import React from 'react';
import * as visualAssets from "./visualAssets.jsx";

import * as audioTools from "./AudioTools.js";

export const K_MARKER_WIDTH = 25;
export const K_MARKER_HEIGHT = 55;

const needleStyle ={
  backgroundImage: visualAssets.soundmapNeedleURL,
  backgroundSize: "contain",
  position:"relative",
  display:"inline-block",
 /* width:K_MARKER_WIDTH,
  height:K_MARKER_HEIGHT,
  left:-13,
  top:-55,*/
  //zIndex:10,
  backgroundRepeat:"no-repeat",
}

const needleStyleEmpty = {...needleStyle,
  backgroundImage:visualAssets.soundmapNeedleEmptyURL,
  //zIndex:300,
  }

const needleCountStyle = {
  display:"block",
  width: "70%",
  //backgroundColor:"red",
  height:"25%",
  margin:"auto",
  marginTop:"20%",
  textAlign:"center",
  verticalAlign:"center",
  fontSize:16,
}
const outerBoxStyle = {
  position:"relative",
}

const infoBoxStyle = {
  zIndex:150,
  verticalAlign:"top",
  position:"relative",
  //backgroundColor: "white",
  display:"inline-block",
  overflow: "hidden",
  backgroundImage: visualAssets.freameRectURL,
  backgroundSize: "100% 100%",
}

const infoBoxStyleSelected = {...infoBoxStyle, height:100};

const tagHeight = 16;

const tagWrapperStyle=
{
  flex:1,
  paddingVertical:0,
  //justifyContent:"flex-end",
  //flexWrap:"wrap",
  //marginBottom:-tagHeight,
  //backgroundColor:"#F89"
}

const tagStyle = {
  display:"inline-block",
  color:"#555555",
  //backgroundColor:"#EEEEEE",
  //marginHorizontal:3,
  paddingLeft: 0,
  //paddingHorizontal:2,
  height:tagHeight,
  //fontSize:tagHeight * 0.8,
}


const listNameStyle = {
  fontWeight:"bold",
  color:"#444444",
  /*backgroundColor:"#FF9999", */
  includeFontPadding:false,
  //fontSize: 14,
}

const listTitleStyle = {
  flex:1,
  //fontSize: 14,
  fontStyle:"italic",
  color:"#444444"
}

const greyedBoxStyle = Object.assign({}, outerBoxStyle, {opacity:0.5});

const needleStyleHover = Object.assign({}, needleStyle, {width:K_MARKER_WIDTH * 2, height:K_MARKER_HEIGHT * 2, left: -25, top: -110});

const playerStyle = {
  display:"block",
  width:"90%",
  margin: "auto",
  marginTop:8,
  //backgroundColor:"green",
  //height:48,
  //position:"absolute",
  //bottom:8, left:8, right:8,
}

export class SoundmapClusterNeedle extends React.Component {
  
  constructor(props)
  {
    super(props);
  }

  select(e)
  {
    this.props.onClusterClick(this.props.cluster);
  }

  render()
  {
    const clusterId = this.props.cluster.id;

    const isHovering = clusterId == this.props.hoverKey;
    const isSelected = clusterId == this.props.selectedKey;
    const isLarge = (isHovering /*&& this.props.selectedKey == null*/) || isSelected;
    const isShowingInfo = (isHovering && this.props.selectedKey == null) || isSelected;
    const isGreyedOut = false;//this.props.selectedKey != null && !isSelected && !isHovering;
    
    return(
      <div  className={/*this.props.$hover*/ isLarge ? "needleLargeContainer" : "needleSmallContainer" } style={isGreyedOut ? greyedBoxStyle : outerBoxStyle}>
          <div onClick={this.select.bind(this)} className={ isLarge  ? "needleLarge" : "needleSmall" } style={needleStyleEmpty}>
          <div style={needleCountStyle}>
            {this.props.cluster.count}
          </div>
          </div>
         </div>
      )
  }
}

export class SoundmapNeedle extends React.Component {
   constructor(props)
   {
      super(props);
      this.state = {
        isPlaying:false,
        audioIsLoaded: false,
      }
      this.hasBeenSelected = false;
      this.loadedBuffer = null;
      this.bufferSource = null;
   }

   componentDidMount()
   {
     
   }

   componentWillUnmount()
   {
    const isSelected = this.props.selectedKey == this.props.keyId;
    
    if(isSelected)
      this.props.onSelect(null);
    
    this.stopBufferIfRunning();
    
   }

   stopBufferIfRunning()
   {
      if(this.state.isPlaying && this.bufferSource != null)
      {
        //console.log("Stopping");
        this.bufferSource.stop();
        this.setState({isPlaying:false});
    }
   }
	
  togglePlay()
  {
    if(this.state.audioIsLoaded)
    {
      const isPlaying = this.state.isPlaying;

      if(isPlaying)
        this.bufferSource.stop();
      else
      {
        const audioCtx = this.props.audioCtx;
        this.bufferSource = audioCtx.createBufferSource();
        this.bufferSource.buffer = this.loadedBuffer;
        this.bufferSource.connect(audioCtx.destination); // connect the source to the context's destination (the speakers)
        this.bufferSource.onended = ()=>{this.setState({isPlaying:false});}
        this.bufferSource.start();
      }

      this.setState({isPlaying: !isPlaying});
    }
  }
  select(e)
  {
    //e.stopPropagation();
    //e.preventDefault();
    if(!this.hasBeenSelected)
    {
      const audioFailed = () => {
        console.log("Audio Failed to load: ", this.props.data.file_name);
      }

      const audioLoaded = (buffer) => {
        this.loadedBuffer = buffer; // tell the source which sound to play  
        this.setState({audioIsLoaded: true});
      }

      //console.log("Trying to load: ", this.props.data.file_name);
      audioTools.loadAudioFile(globalMediaPath + this.props.data.file_name,
        this.props.audioCtx, audioLoaded, audioFailed, null);

      this.hasBeenSelected = true;
    }
    //console.log("Select klik");
    const isSelected = this.props.keyId == this.props.selectedKey;
    this.props.onSelect(isSelected ? null : this.props.keyId);
  }

  infoClick(e)
  {
    //console.log("Info click");
    /* e.stopPropagation();
    e.preventDefault();
    */
  }
  componentWillReceiveProps(nextProps)
  {
    if(this.state.isPlaying && nextProps.selectedKey != nextProps.keyId)
    {
      //console.log("Should Stop");
       this.stopBufferIfRunning();
    }
  }

   render() {
    const isHovering = this.props.keyId == this.props.hoverKey;
    const isSelected = this.props.selectedKey == this.props.keyId;
    const isLarge = (isHovering /*&& this.props.selectedKey == null*/) || isSelected;
    const isShowingInfo = (isHovering && this.props.selectedKey == null) || isSelected;
    const isGreyedOut = false;//this.props.selectedKey != null && !isSelected && !isHovering;
    const infoClassName = isShowingInfo ? ( isSelected ? "needleInfoLargeExpanded" : "needleInfoLarge") : "needleInfoSmall";
      return (
        <div  className={/*this.props.$hover*/ isLarge ? "needleLargeContainer" : "needleSmallContainer" } style={isGreyedOut ? greyedBoxStyle : outerBoxStyle}>
          <div onClick={this.select.bind(this)} className={ isLarge  ? "needleLarge" : "needleSmall" } style={needleStyle}/>
          <div  onClick={this.infoClick.bind(this)} className={ infoClassName/*isShowingInfo ? "needleInfoLarge" : "needleInfoSmall"*/} style={infoBoxStyle}>
            <div style={listNameStyle}>{this.props.data.user}</div>
            <div style={listTitleStyle}>{this.props.data.name}</div>
            <div style={tagWrapperStyle}>
              {this.props.data.tagNames.map((t, i)=><div key={i} style={tagStyle}>{t}&nbsp;&nbsp;</div>)}
            </div>
            {isSelected ? <div style={playerStyle}>
              <PlayButton active={this.state.audioIsLoaded} onClick={this.togglePlay.bind(this)} isPlaying={this.state.isPlaying}/>
            </div> : null }
          </div>
         </div>
      );
   }
}

const playBtnStyle = {
  //align:"center",
  backgroundImage: visualAssets.playIconURL,
  backgroundSize: "contain",
  position:"relative",
  //display:"inline-block",
  //width:48,
  //height:48,
  margin:"auto",
  zIndex:1000,
  backgroundRepeat:"no-repeat",
}

const stopBtnStyle = {...playBtnStyle, backgroundImage: visualAssets.stopIconURL};

const playBtnInactive = {...playBtnStyle, opacity:0.5};

const PlayButton = (props)=>
{
  //console.log("Showing button: ", props);
  const style = props.active ? (props.isPlaying ? stopBtnStyle : playBtnStyle) : playBtnInactive;
  return(
    <div className={"playBtn"} onClick={props.onClick} style={style} />
    );
}


// WEBPACK FOOTER //
// ./js/MapElements.jsx